namespace $.$$ {
	type Shift = $exso_sheets_shift
	export class $exso_sheets_shifts_class extends $.$exso_sheets_shifts_class {
		@$mol_mem_key
		parse(data: Record<string, string>) {
			const downtime = parseFloat(data.downtime)
			let tech_downtime = 0
			let org_downtime = 0
			if (downtime > 0) {
				const note = `${data.note}`.toLowerCase()
				const reasons = new Set(note.split(',').map(s => s.trim()))
				if (reasons.has('офр')) org_downtime = downtime - 60 * (reasons.size - 1)
				tech_downtime = downtime - org_downtime
			}
			const date = new $mol_time_moment(new Date(data.date))
			return {
				supervisor: data.supervisor,
				fuel: parseFloat(data.fuel),
				wells_count: parseFloat(data.wells_count),
				redrill: parseFloat(data.redrill),
				tech_downtime: tech_downtime,
				downtime: downtime,
				org_downtime: org_downtime,
				note: data.note,
				shift: (this.shift() as any)[data.shift],
				shift_num: parseInt(data.shift),
				value: parseFloat(data.value),
				date: date,
				place: data.place,
				device: data.device,
				date_shift: `${this.$.$exso_format.day(date)} (${data.shift})`,
				id: [data.place, data.device, data.date, data.shift].join('/'),
				block: data.block.toString().split(',').join(', '),
				compressor: data.compressor,
				fuel_compressor: parseFloat(data.fuel_compressor),
				fuel_device: parseFloat(data.fuel_device),
				hours_compressor: parseFloat(data.hours_compressor) * 60,
				hours_device: parseFloat(data.hours_device) * 60,
			} satisfies Shift
		}
	}
	export const $exso_sheets_shifts = new $exso_sheets_shifts_class() as any as $exso_sheets<
		ReturnType<$exso_sheets_shifts_class['parse']>
	>
}
